import axios from 'axios'
import { BASE_URL } from '../apiConfig'

/**
 * Shared axios instance used across the application.
 * Centralising the client allows unified configuration
 * such as headers, interceptors, and error handling.
 */
const apiClient = axios.create({
  baseURL: BASE_URL,
})

// Re-export selected axios helpers for convenience.
apiClient.isCancel = axios.isCancel
apiClient.CancelToken = axios.CancelToken
apiClient.all = axios.all
apiClient.spread = axios.spread

/**
 * Utility for updating default headers (e.g., auth token).
 */
export const setDefaultHeader = (key, value) => {
  if (value === undefined || value === null || value === '') {
    delete apiClient.defaults.headers.common[key]
    return
  }
  apiClient.defaults.headers.common[key] = value
}

/**
 * Clears previously set default headers.
 */
export const clearDefaultHeader = (key) => {
  delete apiClient.defaults.headers.common[key]
}

export default apiClient
